import { assertScalarString } from "./encoding";
import { fail } from "./errors";

const ASCII_TRIM_CODE_POINTS = new Set([0x09, 0x0a, 0x0b, 0x0c, 0x0d, 0x20]);

function isAsciiTrim(character: string | undefined): boolean {
  return (
    character !== undefined &&
    ASCII_TRIM_CODE_POINTS.has(character.codePointAt(0)!)
  );
}

function foldAsciiUpper(character: string): string {
  const codePoint = character.codePointAt(0)!;
  if (codePoint >= 0x41 && codePoint <= 0x5a) {
    return String.fromCodePoint(codePoint + 0x20);
  }
  return character;
}

export function normalizeSeed(rawSeed: string): string {
  assertScalarString(rawSeed, "rawSeed");
  const codePoints = Array.from(rawSeed.normalize("NFC"));

  let start = 0;
  let end = codePoints.length;
  while (start < end && isAsciiTrim(codePoints[start])) {
    start += 1;
  }
  while (end > start && isAsciiTrim(codePoints[end - 1])) {
    end -= 1;
  }

  const normalized = codePoints
    .slice(start, end)
    .map(foldAsciiUpper)
    .join("");
  if (normalized.length === 0) {
    fail("EMPTY_SEED", "Seed is empty after normalization", "rawSeed");
  }
  return normalized;
}
